<script lang="ts">
	import { tweened } from 'svelte/motion';

	let {
		ratio = 1.387,
		fontSize = 30,
		duration = 8000,
		text = 'LIFE IS LIVE',
		paused = false
	}: {
		ratio?: number;
		fontSize?: number;
		duration?: number;
		text?: string;
		paused?: boolean;
	} = $props();

	const margin = fontSize * 0.75;

	let length = $state(0);
	let path: SVGPathElement | undefined;

	const offset = tweened(0, {
		duration: 0,
		easing: (t) => t
	});

	$effect(() => {
		let timeoutId: number | undefined;

		const start = () => {
			window.clearTimeout(timeoutId);
			offset.set(0);
			offset.set(-length / 2, { duration });
			timeoutId = window.setTimeout(start, duration);
		};

		if (!paused) start();

		return () => {
			window.clearTimeout(timeoutId);
		};
	});

	$effect(() => {
		length = path?.getTotalLength() ?? 0;
	});
</script>

<svg
	class="oval-text-spinner"
	xmlns="http://www.w3.org/2000/svg"
	viewBox={`${-margin} ${-margin} ${100 + margin * 2} ${100 * ratio + margin * 2}`}
>
	<defs>
		<path
			id="note"
			d={`M50 ${100 * ratio}
			A50 ${50 * ratio} 0 0 1 0 ${50 * ratio}
			A50 ${50 * ratio} 0 0 1 50 0
			A50 ${50 * ratio} 0 0 1 100 ${50 * ratio}
			A50 ${50 * ratio} 0 0 1 50 ${100 * ratio}
			Z`}
			bind:this={path}
		/>
	</defs>
	<text
		font-family="'GT Flexa', Arial, Helvetica, sans-serif"
		font-weight="500"
		font-size={fontSize}
	>
		<textPath
			startOffset={$offset}
			href="#note"
			method="stretch"
			lengthAdjust="spacingAndGlyphs"
			spacing="auto"
			textLength={length * 1.5}>{text} {text} {text}&nbsp;</textPath
		>
	</text>
</svg>
